export const FINISH_OPERATION = 'FINISH_OPERATION';
export default function finishOperation(id) {
  return {
    type: FINISH_OPERATION,
    id,
  };
}
